/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize SeroStatusHepatitisB View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './SeroStatusHepatitisBView';

export const mapStateToPropsSeroStatusHepatitisB = mapStateToProps;
export const mapDispatchToPropsSeroStatusHepatitisB = mapDispatchToProps;

export default connect(
  mapStateToPropsSeroStatusHepatitisB,
  mapDispatchToPropsSeroStatusHepatitisB
)(View);
